export const DEFAULT_TABLE_PAGE_SIZE = 50

// Dashboard table widgets are sized for a tile, not a page
export const DEFAULT_TABLE_WIDGET_PAGE_SIZE = 10

export const SIMPLE_PAGE_TABLE_SCROLL_REDUCER = 160
export const PAGE_WITH_TABS_TABLE_SCROLL_REDUCER = 190
export const DETAIL_PAGE_TABLE_SCROLL_REDUCER = 220
export const PAGE_WITH_TABS_AND_HEADER_TABLE_SCROLL_REDUCER = 250
